export enum LeftOfTableModeEnum {
  LOTT = 'LOTT',
  LOTW = 'LOTW',
}
